module.exports = "<div class=\"ot-burger\">\n  <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openMenuModal()\">\n    <span class=\"glyphicon glyphicon-align-justify\"></span>\n  </button>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/directives/navigation/burger.html
 ** module id = 279
 ** module chunks = 1
 **/